<template>
  <div class="h5-page">
    <div class="header-wrapper">
      <img src="../../assets/pc/logo.png" alt="logo" class="logo" />
      <div>
        <div class="header">
          {{ header }}
        </div>
        <div class="header-desc">
          {{ headerDesc }}
        </div>
        <!-- <ul class="header-desc">
          <li v-for="(item, index) in headerDesc" :key="index">
            {{ item }}
          </li>
        </ul> -->
      </div>
    </div>
    <div class="action-area">
      <div
        class="action-item"
        v-for="item in actionData"
        :key="item.color"
        :style="`flex-direction: ${item.flexDirection}`"
      >
        <img :src="item.actionImage" alt="" class="action-item-image" />
        <div class="action-item-content">
          <img :src="item.arrowImage" alt="" class="arrow-img" />
          <div class="dot" :style="`background:${item.color}`"></div>
          <div class="action-item-text">
            <div class="action-item-title">
              {{ item.title }}
            </div>
            <div class="action-item-desc">
              {{ item.desc }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="feedback">
      <div class="feedback-header">
        <div class="feedback-title">{{ feedbackTitle }}</div>
      </div>
      <div>
        <div class="feedback-item" v-for="item in feedbacks" :key="item.user">
          <div
            class="feedback-item-user"
            :style="`background: ${item.background}`"
          >
            {{ item.user }}
          </div>
          <div class="feedback-item-content">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <div class="study">
      <div class="study-title">{{ expect }}</div>
      <div class="study-desc">{{ use }}</div>
      <img src="../../assets/pc/wxqrcode.jpg" alt="" class="study-qrcode" />
      <div class="study-line"></div>
    </div>
    <div class="footer">
      <img src="../../assets/pc/qrcode.png" alt="" class="footer-qrcode" />
      <div class="footer-version">
        <p>
          {{ version
          }}<a href="https://beian.miit.gov.cn/" target="_blank"
            >粤ICP备2022062693号</a
          >
        </p>
        <p>
          {{ extra }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import dataMixin from "../../mixin/index";
export default {
  mixins: [dataMixin],
};
</script>

<style lang="scss" scoped>
.h5-page {
  position: relative;

  .logo {
    width: 84px;
    height: 21px;
    text-align: center;
    margin-top: 28px;
  }

  .header-wrapper {
    position: relative;
    background: #feb801;
    padding-bottom: 50px;

    // &:after {
    //   content: '';
    //   position: absolute;
    //   height: 10px;
    //   left: 0;
    //   right: 0;
    //   bottom: -10px;
    //   // background: radial-gradient(
    //   //   100px 150px ellipse at top,
    //   //   #feb801 100px,
    //   //   transparent 120px
    //   // );
    //   // background-size: 100px 150px;
    // }
  }

  .header {
    font-family: zhihu;
    margin-top: 12px;
    font-weight: 400;
    font-size: 22px;
    line-height: 26px;
    letter-spacing: 0;
    color: #ffffff;
    text-align: center;
  }

  .header-desc {
    margin-top: 12px;
    padding: 0 26px;
    font-weight: 900;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    color: #ffffff;
    text-align: center;
  }

  .arrow-img {
    position: absolute;
    width: 124px;
    height: 160px;
    top: 40px;
    left: 40px;
  }

  .action-area {
    padding: 14px;
  }

  .action-item {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-top: 40px;
    }

    &:last-child {
      margin-bottom: 30px;
    }

    &:nth-child(odd) {
      .action-item-content {
        padding-left: 10px;
      }
    } //奇数行

    &:nth-child(even) {
      .action-item-content {
        padding-right: 10px;
      }
    } //偶数行

    &-image {
      width: 140px;
      height: 140px;
    }

    &-content {
      display: flex;
      position: relative;
      align-items: baseline;
    }

    &-text {
      flex: 1;
    }

    &-title {
      font-family: zhihu;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #221f1f;
      letter-spacing: 0;
      text-align: justify;
    }

    .dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 5px;
    }

    &-desc {
      font-weight: 900;
      font-size: 12px;
      line-height: 20px;
      color: #9c9c9c;
      letter-spacing: 0;
      text-align: justify;
      margin-top: 5px;
    }
  }
  .feedback {
    background-color: #e9e9e9;
    position: relative;
    padding: 12px 32px 16px;

    &-header {
      padding-bottom: 10px;
    }

    &-title {
      position: relative;
      font-family: PingFang-SC-Regular;
      font-weight: 400;
      font-size: 13px;
      line-height: 18px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      &:after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: -10px;
        transform: translate(-50%, 50%);
        width: 78px;
        height: 2px;
        background: #969696;
      }
    }

    &-item {
      position: relative;
      margin-top: 18px;
      display: flex;
      &-user {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        color: #ffffff;
        padding: 2px;
        font-weight: 600;
        font-size: 5px;
        color: #ffffff;
        letter-spacing: 0;
      }

      &-content {
        display: flex;
        align-items: center;
        // height: 44px;
        background: #ffffff;
        border-radius: 8px;
        font-family: PingFangSC-S0pxibold;
        font-weight: 600;
        font-size: 12px;
        line-height: 17px;
        color: #221f1f;
        letter-spacing: 0;
        text-align: justify;
        padding: 10px 20px 10px 32px;
      }
    }
  }
  .study {
    padding: 12px 10px 0;

    position: relative;
    &-title {
      font-family: zhihu;
      font-weight: 400;
      font-size: 17px;
      line-height: 22px;
      color: #feb801;
      letter-spacing: 0;
    }

    &-desc {
      padding-top: 17px;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #feb801;
      letter-spacing: 0;
      padding-bottom: 16px;
    }

    &-qrcode {
      width: 88px;
      height: 88px;
    }

    &-line {
      margin-top: 17px;
      width: 100%;
      height: 1px;
      background-color: #feb801;
    }
  }
  .footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 13px 47px 13px 23px;
    &-qrcode {
      width: 51px;
      height: 51px;
    }
    &-version {
      white-space: pre-wrap;
      text-align: start;
      padding-left: 25px;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      color: #c4c4c4;
      letter-spacing: 0;
    }
  }
}
</style>
